"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[461,7236,2074],{

/***/ 87959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64836);
/* harmony import */ var _Layers_LayerGeoJSON__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33724);
/* harmony import */ var _utils_cartography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19371);
/* harmony import */ var _Layers_DeflateLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52889);






var boundsOptions = {
    padding: [
        20,
        20
    ]
};
var AuctionCardMap = function(param) {
    var cadastralPlots = param.cadastralPlots;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_cartography__WEBPACK_IMPORTED_MODULE_2__/* .cadastralPlotsToGeoJSONData */ .gP)(cadastralPlots);
    }, [
        cadastralPlots
    ]), bounds = ref[0], geoJSONData = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__["default"], {
        staticMap: true,
        bounds: bounds,
        fallback: !bounds,
        boundsOptions: boundsOptions,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layers_DeflateLayer__WEBPACK_IMPORTED_MODULE_4__/* .DeflateLayer */ .O, {
            children: geoJSONData.map(function(data, key) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layers_LayerGeoJSON__WEBPACK_IMPORTED_MODULE_5__/* .LayerGeoJSON */ .B, {
                    color: "secondary",
                    data: data,
                    interactive: false,
                    fill: false
                }, key);
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (AuctionCardMap);


/***/ }),

/***/ 52889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ DeflateLayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78794);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48090);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75920);
/* harmony import */ var _Marker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67472);
/* harmony import */ var Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8872);
/* harmony import */ var Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31151);
/* harmony import */ var leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46829);
/* harmony import */ var leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6__);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  w-8\n  y-8\n  text-center\n  font-sans\n  font-semibold\n  ml-1\n  mt-1\n  rounded-2xl\n  bg-secondary-500\n  leading-[32px]\n  text-white\n  hover:bg-secondary-600\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  p-2\n  inline-block\n  bg-secondary-500\n  hover:bg-secondary-600\n  active:bg-secondary-700\n  rounded-lg\n  translate-y-[-11px]\n  -translate-x-2/4\n  ml-2\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Cluster = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject());
var Price = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject1());
var AuctionPrice = function(param) {
    var highestBidObject = param.highestBidObject, startingBid = param.startingBid;
    var price = highestBidObject ? highestBidObject.price : startingBid;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Price, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "text-white font-semibold",
            children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatMoney */ .lb)(price)
        })
    }));
};
var markerOptions = function(param) {
    var feature = param.feature;
    if (feature === null || feature === void 0 ? void 0 : feature.properties.id) {
        return {
            icon: (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.divIcon)({
                html: (0,react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToStaticMarkup)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuctionPrice, _objectSpread({}, feature.properties)))
            })
        };
    }
    return {
        icon: _Marker__WEBPACK_IMPORTED_MODULE_8__.icon
    };
};
var DeflateLayer = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_9__/* .createPathComponent */ .Au)(function(_param, context) {
    var _minSize = _param.minSize, minSize = _minSize === void 0 ? 30 : _minSize, props = _objectWithoutProperties(_param, [
        "minSize"
    ]);
    var markerLayer = (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.markerClusterGroup)({
        zoomToBoundsOnClick: false,
        maxClusterRadius: 60,
        iconCreateFunction: function(cluster) {
            return new leaflet__WEBPACK_IMPORTED_MODULE_1__.DivIcon({
                html: (0,react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToString)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cluster, {
                    children: cluster.getChildCount()
                })),
                className: 'cluster',
                iconSize: new leaflet__WEBPACK_IMPORTED_MODULE_1__.Point(40, 40)
            });
        },
        polygonOptions: {
            fillColor: (_config__WEBPACK_IMPORTED_MODULE_10___default().colors.secondary[500]),
            color: (_config__WEBPACK_IMPORTED_MODULE_10___default().colors.secondary[500])
        }
    });
    markerLayer.on('clusterclick', function(event) {
        var clusterBounds = event.propagatedFrom.getBounds();
        var polygonBounds = layerContainer.getLayers().map(function(layer) {
            if (!('getBounds' in layer)) return;
            var bounds = layer.getBounds();
            return (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.latLngBounds)(bounds.getSouthWest(), bounds.getNorthEast());
        }).filter(function(bounds) {
            return bounds ? bounds.intersects(clusterBounds) : false;
        }).reduce(function(layerBounds, bounds) {
            return layerBounds.extend(bounds);
        });
        context.map.fitBounds(polygonBounds, {
            padding: [
                20,
                20
            ]
        });
    });
    var layerContainer = (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.deflate)(_objectSpread({
        minSize: minSize,
        markerLayer: markerLayer,
        markerOptions: markerOptions
    }, props));
    return {
        instance: layerContainer,
        context: _objectSpread({}, context, {
            layerContainer: layerContainer
        })
    };
});



/***/ }),

/***/ 33724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LayerGeoJSON; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63964);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57820);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_0__);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var colors = (_config__WEBPACK_IMPORTED_MODULE_0___default().colors);
var ref, ref1, ref2, ref3;
var LayerGeoJSON = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(react_leaflet__WEBPACK_IMPORTED_MODULE_2__/* .GeoJSON */ .Q).attrs(function(param) {
    var color = param.color, _intensity = param.intensity, intensity = _intensity === void 0 ? 500 : _intensity;
    var ref5, ref4;
    return {
        style: {
            color: (ref1 = (ref = (ref5 = colors[color]) === null || ref5 === void 0 ? void 0 : ref5[intensity]) !== null && ref !== void 0 ? ref : colors[color]) !== null && ref1 !== void 0 ? ref1 : color,
            fillColor: (ref3 = (ref2 = (ref4 = colors[color]) === null || ref4 === void 0 ? void 0 : ref4[intensity]) !== null && ref2 !== void 0 ? ref2 : colors[color]) !== null && ref3 !== void 0 ? ref3 : color
        }
    };
}).withConfig({
    componentId: "sc-95b4f36a-0"
})(_templateObject());


/***/ }),

/***/ 67472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Maps_Marker; },
  "icon": function() { return /* binding */ icon; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(15623);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/Marker.js
var Marker = __webpack_require__(94053);
// EXTERNAL MODULE: ../../node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(48090);
// EXTERNAL MODULE: ../core/src/components/Maps/Popups/index.tsx
var Popups = __webpack_require__(26421);
;// CONCATENATED MODULE: ../assets/icons/location-gold.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLocationGold = function SvgLocationGold(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M44.625 21.25c0 14.875-19.125 27.625-19.125 27.625S6.375 36.125 6.375 21.25a19.125 19.125 0 0 1 38.25 0Z",
    fill: "#D9B310"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.5 27.625a6.375 6.375 0 1 0 0-12.75 6.375 6.375 0 0 0 0 12.75Z",
    fill: "#87700D"
  })));
};

/* harmony default export */ var location_gold = (SvgLocationGold);
;// CONCATENATED MODULE: ../core/src/components/Maps/Marker.tsx







var iconUrl = 'data:image/svg+xml,' + encodeURIComponent((0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(location_gold, {
    width: 51,
    height: 51
})));
var icon = (0,leaflet_src.icon)({
    iconUrl: iconUrl,
    iconRetinaUrl: iconUrl,
    iconSize: [
        51,
        51
    ],
    className: 'filter drop-shadow-marker',
    iconAnchor: [
        25.5,
        51
    ],
    popupAnchor: [
        0,
        -25.5
    ]
});
var addLineBreaks = function(content) {
    return content.split('\n').map(function(text, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                text,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        }, "".concat(text, "-").concat(index));
    });
};
var Marker_Marker = function(param) {
    var position = param.position, popup = param.popup;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Marker/* Marker */.J, {
        icon: icon,
        position: position,
        children: popup && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups/* Popup */.G, {
            children: addLineBreaks(popup)
        })
    }));
};
/* harmony default export */ var Maps_Marker = (Marker_Marker);


/***/ }),

/***/ 26421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ Popup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89507);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26692);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97872);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Popup = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var map = (0,react_leaflet__WEBPACK_IMPORTED_MODULE_2__/* .useMap */ .Sx)();
    var close = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return map.closePopup();
    }, [
        map
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_leaflet__WEBPACK_IMPORTED_MODULE_3__/* .Popup */ .G, _objectSpread({
        pane: "popupPane",
        autoPanPadding: [
            60,
            10
        ],
        closeButton: false
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .CloseButton */ .P, {
                className: "absolute top-1 right-1",
                onClick: close
            }),
            children
        ]
    })));
});



/***/ }),

/***/ 19371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n5": function() { return /* binding */ getCadastralPlotCenter; },
/* harmony export */   "gP": function() { return /* binding */ cadastralPlotsToGeoJSONData; },
/* harmony export */   "lL": function() { return /* binding */ googleDirectionsURL; },
/* harmony export */   "um": function() { return /* binding */ geoJSONPolylabelPositions; }
/* harmony export */ });
/* unused harmony exports polygonStringsToGeoJSONData, stringToWktInstance, wktPolygonToBounds, polygonPolylabelPosition */
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53467);
/* harmony import */ var wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var polylabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54670);
/* harmony import */ var polylabel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(polylabel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _turf_area__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26350);
/* harmony import */ var _turf_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20755);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var minimumLabelablePolygonArea = 100;
function polygonStringsToGeoJSONData(polygonArray) {
    var polygons = polygonArray.filter(function(item) {
        return !!item;
    });
    if (!polygons.length) {
        return [
            ,
            []
        ];
    }
    var wktPolygons = polygons.map(stringToWktInstance);
    var geoJSON = wktPolygons.map(function(wktPolygon) {
        return wktPolygon.toJson();
    });
    return [
        wktPolygonToBounds(wktPolygons.reduce(function(rootWktPolygon, wktPolygon) {
            return rootWktPolygon.merge(wktPolygon);
        })),
        geoJSON, 
    ];
}
function getCadastralPlotCenter(cadastralPlot) {
    if (!cadastralPlot) return;
    var boundary = cadastralPlot.boundary, latitude = cadastralPlot.latitude, longitude = cadastralPlot.longitude;
    var bounds;
    if (boundary) {
        bounds = wktPolygonToBounds(stringToWktInstance(boundary));
    } else if (latitude && longitude) {
        bounds = new leaflet__WEBPACK_IMPORTED_MODULE_0__.LatLngBounds([
            [
                latitude,
                longitude
            ]
        ]);
    }
    return bounds === null || bounds === void 0 ? void 0 : bounds.getCenter();
}
function stringToWktInstance(polygon1) {
    return new (wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1___default().Wkt)(polygon1);
}
function wktPolygonToBounds(wktPolygon) {
    return wktPolygon.toObject().getBounds();
}
function cadastralPlotsToGeoJSONData(cadastralPlots) {
    var ref = _slicedToArray(polygonStringsToGeoJSONData(cadastralPlots.map(function(param) {
        var boundary = param.boundary;
        return boundary;
    })), 2), boundaryBounds = ref[0], boundaryGeoJSON = ref[1];
    var latLonArray = cadastralPlots.filter(function(param) {
        var boundary = param.boundary, latitude = param.latitude, longitude = param.longitude;
        return !boundary && latitude && longitude;
    }).map(function(param) {
        var latitude = param.latitude, longitude = param.longitude;
        return [
            latitude,
            longitude
        ];
    });
    var ref1 = [
        latLonArray.length ? new leaflet__WEBPACK_IMPORTED_MODULE_0__.Polyline(latLonArray).getBounds() : undefined,
        latLonArray.map(function(latlon) {
            return new leaflet__WEBPACK_IMPORTED_MODULE_0__.Polygon([
                latlon
            ]).toGeoJSON().geometry;
        }), 
    ], latLonBounds = ref1[0], latLongGeoJSON = ref1[1];
    return [
        boundaryBounds && latLonBounds ? boundaryBounds.extend(latLonBounds) : boundaryBounds || latLonBounds,
        _toConsumableArray(boundaryGeoJSON).concat(_toConsumableArray(latLongGeoJSON)), 
    ];
}
function googleDirectionsURL(coords) {
    var point = (0,leaflet__WEBPACK_IMPORTED_MODULE_0__.latLng)(coords);
    return "https://www.google.com/maps/dir/?api=1&origin=&destination=".concat(point.lat, ",").concat(point.lng, "&travelmode=driving&dir_action=navigate");
}
function geoJSONPolylabelPositions(feature) {
    var polygons = feature.type === 'Polygon' ? [
        feature.coordinates
    ] : feature.coordinates;
    return polygons.filter(function(coords) {
        return (0,_turf_area__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_turf_helpers__WEBPACK_IMPORTED_MODULE_4__/* .polygon */ .yu)(coords)) >= minimumLabelablePolygonArea;
    }).map(polygonPolylabelPosition);
}
function polygonPolylabelPosition(coords) {
    var ref = _slicedToArray(polylabel__WEBPACK_IMPORTED_MODULE_2___default()(coords), 2), lng = ref[0], lat = ref[1];
    return [
        lat,
        lng
    ];
}


/***/ })

}]);